import { render, staticRenderFns } from "./DeliveriesComponent.vue?vue&type=template&id=94b6b1c2&"
import script from "./DeliveriesComponent.vue?vue&type=script&lang=js&"
export * from "./DeliveriesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports